<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
         <router-link
      :to="
        '/CompanyMadioniaReportPrint?' +
          'from=' +
          date_from +
          '&to=' +
          date_to
      "
      target="_blank"
    >
      <v-icon>print</v-icon>
    </router-link>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b><u> تقرير مديونيات الشركة </u> </b>
          </p>
        </v-flex>
        <br />
        <v-flex xs12 sm6 md4
          ><b>جميع المديونيات : </b> {{ all_of_total }}</v-flex
        >
        <v-flex xs12 sm6 md4><b>جميع المبيعات : </b> {{ all_sales }}</v-flex>
        <v-flex xs12 sm6 md4><b>جميع المرتجعات : </b> {{ all_rebacks }}</v-flex>
        <v-flex xs12 sm6 md4><b>جميع السدادات : </b> {{ all_sadads }}</v-flex>
        <v-flex xs12 sm6 md4><b>جميع الخصومات : </b> {{ all_khasms }}</v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template
          slot="items"
          slot-scope="props"
          v-if="props.item.madionia > 0"
        >
          <td>{{ props.item.client.code }}</td>
          <td class="text-xs-right">{{ props.item.client.name }}</td>
          <td class="text-xs-right">{{ props.item.client.rasid_efttahi }}</td>
          <td class="text-xs-right">
            {{
              props.item.client && props.item.client.mandob_sales
                ? props.item.client.mandob_sales.name
                : ""
            }}
          </td>
          <td class="text-xs-right">
            {{
              props.item.client && props.item.client.region
                ? props.item.client.region.name
                : ""
            }}
          </td>
          <td class="text-xs-right">{{ props.item.madionia }}</td>
          <td class="text-xs-right">{{ props.item.sales }}</td>
          <td class="text-xs-right">{{ props.item.rebacks }}</td>
          <td class="text-xs-right">{{ props.item.sadads }}</td>
          <td class="text-xs-right">{{ props.item.khasms }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير</div>
    </v-container>
  </div>
</template>

<script>
import {
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  khazina,
  CompanyMadioniaReport
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [11400, 11800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " كود العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "الرصيد الافتتاحي",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "مندوب المبيعات",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المنطقة",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " المديونية   ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المبيعات",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المرتجعات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السدادات",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الخصومات",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_branch: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    branches: [],
    fatworas: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail: {},
    all_of_total: 0,
    all_sales: 0,
    all_rebacks: 0,
    all_sadads: 0,
    all_khasms: 0,
    count_of_count: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      this.CompanyMadioniaReport();
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_branch = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_branch.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_branch.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_branch.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_branch.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem(order) {
      this.item_detail = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    CompanyMadioniaReport() {
      var frmData = new FormData();
      frmData.append("branch_id", this.select_branch.id);
      frmData.append("date_from", this.date_from);
      frmData.append("date_to", this.date_to);
      CompanyMadioniaReport(frmData).then(response => {
        this.loading = false;
        response.data.myArr.length > 0
          ? (this.fatworas = response.data.myArr)
          : (this.fatworas = []);
        this.all_of_total = response.data.total;
        this.all_sales = response.data.all_sales;
        this.all_rebacks = response.data.all_rebacks;
        this.all_sadads = response.data.all_sadads;
        this.all_khasms = response.data.all_khasms;
      });
    }
  }
};
</script>

<style scoped>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-icon.ml-4.v-icon--link.material-icons.theme--dark {
  font-size: 25px !important;
}
</style>
